import { useHttpClient, type ErrorResponse, type ForbiddenResponse, type NotFoundResponse } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { useVehicleStore } from "shared/vehicles/stores/vehicleStore";

export interface DeleteVehicleRequest {
  vehicleId: string;
}

export type DeleteVehicleResponse = DeleteVehicleSuccessResponse
  | ErrorResponse
  | NotFoundResponse
  | ForbiddenResponse;

export interface DeleteVehicleSuccessResponse {
  ok: true;
}

export function useDeleteVehicle() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useVehicleStore();

  return {
    execute
  };

  async function execute(action: DeleteVehicleRequest) : Promise<DeleteVehicleResponse> {

    const {
      vehicleId
    } = action;

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`vehicle/${vehicleId}`), {
      method: 'DELETE',
      headers,
    });

    const text = translations.value.vehicles.actions.delete;

    const response = await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      processOk() {
        store.remove(action.vehicleId);
        return Promise.resolve({
          ok: true
        });
      },
    });

    return response;
  }
}
